import React, { lazy, Suspense } from "react";
import { Box, CircularProgress } from "@mui/material";
import SignupForm from "../pages/Signup/SignupForm";
import LoginForm from "../pages/Login/LoginForm";
import LogoutPage from "../components/logoutPage/LogoutPage";
import CreditCardBillPaymentHisotryAdmin from "../Admin/AdminPages/CreditCardBillPaymentHisotryAdmin";

const CommissionRates = lazy(() =>
  import("../Admin/AdminPages/Commission/CommissionRates")
);
const CommissionTable = lazy(() =>
  import("../Admin/AdminPages/Commission/CommissionTable")
);
const EditCommissionRate = lazy(() =>
  import("../Admin/AdminPages/Commission/EditCommissionRate")
);
const AdminWallets = lazy(() => import("../Admin/AdminPages/AdminWallets"));
const FundTransfer = lazy(() => import("../Admin/AdminPages/FundTransfer"));
const Notification = lazy(() => import("../Admin/AdminPages/Notification"));
const PendingSettlement = lazy(() =>
  import("../Admin/AdminPages/PendingSettlement")
);
const ProfileAdmin = lazy(() => import("../Admin/AdminPages/ProfileAdmin"));
const Services = lazy(() => import("../Admin/AdminPages/Services/Services"));
const DashboardAdmin = lazy(() => import("../Admin/AdminPages/DashboardAdmin"));
const AnalyticsAdmin = lazy(() => import("../Admin/AdminPages/AnalyticsAdmin"));
const MatmBankAccountList = lazy(() => import("../Admin/AdminPages/MatmBankAccountList"));
const BankVerificationsAdmin = lazy(() => import("../Admin/AdminPages/BankVerificationsAdmin"));
const AccountList = lazy(() => import("../Admin/AdminPages/AccountList"));
const SettlementRequests  = lazy(() => import("../Admin/AdminPages/SettlementRequests"));
const EmployeeDetails = lazy(() =>
  import("../Admin/AdminPages/EmployeeDetails")
);
const EmployeeView = lazy(() => import("../Admin/AdminPages/EmployeeView"));
const Transaction = lazy(() => import("../Admin/AdminPages/Transaction"));
const TxnDetailPage = lazy(() => import("../pages/TxnDetail/TxnDetailPage"));
const BeneAccountList = lazy(() =>
  import("../Admin/AdminPages/BeneAccounstList")
);
const EmployeeCommissionTable = lazy(() =>
  import("../Admin/AdminPages/EmployeeCommission/EmployeeCommissionTable")
);
const EmployeeCommissionRates = lazy(() =>
  import("../Admin/AdminPages/EmployeeCommission/EmployeeCommissionRates")
);
const MerchantLists = lazy(() =>
  import("../Admin/AdminPages/Merchant/MerchantLists")
);
const Certificate = lazy(() => import("../components/Certificate"));
const IdCard = lazy(() => import("../components/IdCard"));
const WelcomeLetter = lazy(() => import("../components/WelcomeLetter"));
const SupportInfo = lazy(() => import("../pages/SupportInfo"));
const NoticeList = lazy(() => import("../pages/Notice/NoticeList"));
const PublicForms = lazy(() => import("../pages/PublicForms"));
const AppSettingsPage = lazy(() =>
  import("../Admin/AdminPages/AppSettings")
);
const SettlementChargeSettings = lazy(() =>
  import("../Admin/AdminPages/Settings/SettlementChargeSettings")
);
const CreditCardBillChargeSettings  = lazy(() =>
  import("../Admin/AdminPages/Settings/CreditCardBillChargeSettings")
);
const DataTransfer = lazy(() =>
  import("../Admin/AdminPages/DataTransfer")
);
const FinkedaDashboard = lazy(() =>
  import("../Admin/AdminPages/FinkedaDashboard")
);
const FinkedaOrders = lazy(() =>
  import("../Admin/AdminPages/FinkedaOrders")
);
const FinkedaRepairOrders = lazy(() =>
  import("../Admin/AdminPages/FinkedaRepairOrders")
);
const FinkedaOrderDetail = lazy(() =>
  import("../Admin/AdminPages/FinkedaOrderDetail")
);
const PgTypes = lazy(() =>
  import("../Admin/AdminPages/FinkedaConfig/PgTypes")
);
const PgTypeForm = lazy(() =>
  import("../Admin/AdminPages/FinkedaConfig/PgTypeForm")
);
const PgCommercials = lazy(() =>
  import("../Admin/AdminPages/FinkedaConfig/PgCommercials")
);
const PgCommercialForm = lazy(() =>
  import("../Admin/AdminPages/FinkedaConfig/PgCommercialForm")
);
const PayoutPricings = lazy(() =>
  import("../Admin/AdminPages/FinkedaConfig/PayoutPricings")
);
const PayoutPricingForm = lazy(() =>
  import("../Admin/AdminPages/FinkedaConfig/PayoutPricingForm")
);
const SystemGuide = lazy(() =>
  import("../Admin/AdminPages/SystemGuide")
);
const ProviderManagement = lazy(() =>
  import("../Admin/AdminPages/ProviderManagement")
);

const CreditCardBillersAdmin = lazy(() =>
  import("../Admin/AdminPages/CreditCardBillersAdmin")
);

const RouteFallback = () => (
  <Box
    sx={{
      minHeight: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <CircularProgress size={36} />
  </Box>
);

const withSuspense = (element) => (
  <Suspense fallback={<RouteFallback />}>{element}</Suspense>
);

export const routes = [
  { path: "/", element: <SignupForm />, isProtected: false },
  {
    path: "/verify/mpin/:username",
    element: <LoginForm />,
    isProtected: false,
  },
  {
    path: "/logout",
    element: <LogoutPage />,
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/dashboard",
    element: withSuspense(<DashboardAdmin />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/analytics",
    element: withSuspense(<AnalyticsAdmin />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/profile",
    element: withSuspense(<ProfileAdmin />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/settlement",
    element: withSuspense(<PendingSettlement />),
    isProtected: true,
    adminOnly: true,
  },
  
  {
    path: "/admin/fund",
    element: withSuspense(<FundTransfer />),
    isProtected: true,
    adminOnly: true,
    superAdminOnly: true,
  },
  {
    path: "/admin/wallets",
    element: withSuspense(<AdminWallets />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/transaction/:serviceSlug",
    element: withSuspense(<Transaction />),
    isProtected: true,
    adminOnly: true,
  },

    {
    path: "/admin/bill/ccbill",
    element: withSuspense(<CreditCardBillPaymentHisotryAdmin />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/credit-card-billers",
    element: withSuspense(<CreditCardBillersAdmin />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/settings/cc-billers",
    element: withSuspense(<CreditCardBillersAdmin />),
    isProtected: true,
    adminOnly: true,
  },

  {
    path: "/admin/txn/:type/:id",
    element: withSuspense(<TxnDetailPage />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/commission-table",
    element: withSuspense(<CommissionTable />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/commission",
    element: withSuspense(<CommissionRates />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/edit-plans/:id",
    element: withSuspense(<EditCommissionRate />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/employee",
    element: withSuspense(<EmployeeDetails />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/employee/:id",
    element: withSuspense(<EmployeeView />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/account",
    element: withSuspense(<AccountList />),
    isProtected: true,
    adminOnly: true,
  },

    {
    path: "/admin/settle-request",
    element: withSuspense(<SettlementRequests/>),
    isProtected: true,
    adminOnly: true,
  },

     {
    path: "/admin/matm-bank-list",
    element: withSuspense(<MatmBankAccountList />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/bank-verifications",
    element: withSuspense(<BankVerificationsAdmin />),
    isProtected: true,
    adminOnly: true,

    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/bene-accounts",
    element: withSuspense(<BeneAccountList />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/notification",
    element: withSuspense(<Notification />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/suports",
    element: withSuspense(<SupportInfo />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/notice",
    element: withSuspense(<NoticeList />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/services",
    element: withSuspense(<Services />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/employee-table",
    element: withSuspense(<EmployeeCommissionTable />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/user-commission/:id",
    element: withSuspense(<EmployeeCommissionRates />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/edit-employee-rate/:id",
    element: withSuspense(<EditCommissionRate />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/welcome-letter",
    element: withSuspense(<WelcomeLetter />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/id-card",
    element: withSuspense(<IdCard />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/certificate",
    element: withSuspense(<Certificate />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/merchants",
    element: withSuspense(<MerchantLists />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/enquiry-form",
    element: withSuspense(<PublicForms />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/app-settings",
    element: withSuspense(<AppSettingsPage />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/settings/settlement-charge",
    element: withSuspense(<SettlementChargeSettings />),
    isProtected: true,
    adminOnly: true,
  },
    {
    path: "/admin/settings/credit-card-charge",
    element: withSuspense(<CreditCardBillChargeSettings  />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/data-transfer",
    element: withSuspense(<DataTransfer />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/finkeda",
    element: withSuspense(<FinkedaDashboard />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/providers",
    element: withSuspense(<ProviderManagement />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/finkeda/orders/:urn",
    element: withSuspense(<FinkedaOrderDetail />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/finkeda/repair-orders",
    element: withSuspense(<FinkedaRepairOrders />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/finkeda/orders",
    element: withSuspense(<FinkedaOrders />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/finkeda/pg-types/add",
    element: withSuspense(<PgTypeForm />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/finkeda/pg-types/:id/edit",
    element: withSuspense(<PgTypeForm />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/finkeda/pg-types",
    element: withSuspense(<PgTypes />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/finkeda/pg-commercials/add",
    element: withSuspense(<PgCommercialForm />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/finkeda/pg-commercials/:id/edit",
    element: withSuspense(<PgCommercialForm />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/finkeda/pg-commercials",
    element: withSuspense(<PgCommercials />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/finkeda/payout-pricing/add",
    element: withSuspense(<PayoutPricingForm />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/finkeda/payout-pricing/:id/edit",
    element: withSuspense(<PayoutPricingForm />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/finkeda/payout-pricing",
    element: withSuspense(<PayoutPricings />),
    isProtected: true,
    adminOnly: true,
  },
  {
    path: "/admin/system-guide",
    element: withSuspense(<SystemGuide />),
    isProtected: true,
    adminOnly: true,
  },
];
